export const mutations = {
  addAttribut(state, attribut) {
    state.attribut = attribut;
  },
  setAttribut(state, attribut) {
    state.attribut = attribut;
  },
  addAttributs(state, attribut) {
    state.attributs = [...attribut];
  },
  addAttributsPage(state, attribut) {
    state.attributs = [...attribut.content];
    console.log(attribut.content);
    state.pagination = {
      pageable: attribut.pageable,
      totalElements: attribut.totalElements,
      totalPages: attribut.totalPages,
    };
  },
};
